var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"connection-page"},[_c('div',{staticClass:"text-section"},[_c('h1',[_vm._v("เชื่อมต่อสำเร็จ...")]),_c('p',[_vm._v("กำลังกลับเข้าสู่ระบบใน 5 วินาที...")])]),_c('div',{staticClass:"image-section"},[_c('img',{staticClass:"success-image",attrs:{"src":"/img/complete.png","alt":"Success"}})])])
}]

export { render, staticRenderFns }